const errors = {
  A001: '권한이 없습니다.',
  A002: '존재하지않은 사용자입니다.',
  A003: '아이디 혹은 비밀번호가 일치하지 않습니다.',
  A004: '인증에 실패하였습니다.',
  A005: '중복된 이메일입니다.',
  A006: '중복된 닉네임입니다.',
  A007: '결제 후 이용해주세요.',
  F001: '이미지 업로드는 jpeg, jpg, png 형식만 가능합니다.',
  M001: '지원하지 않은 HTTP 메서드입니다.',
  P001: '이미 결제된 시리즈입니다.',
  S001: '정의되지 않은 서버 에러입니다.',
  S002: '정의되지 않은 서버 에러입니다.',
  S003: '포인트가 부족합니다.',
  U001: '입력값이 유효하지 않습니다.',
  U002: '입력값의 타입이 유효하지 않습니다.',
};

export const errorToString = code => errors[code];
